"use strict";
/*
node18
npx swagger-typescript-api -p http://localhost:8042/rest/openapi.json \
 --route-types --extract-request-params --extract-request-body --extract-response-body --extract-response-error \
 --sort-routes --sort-types \
 --modular --axios \
 -o src/types/api/
*/
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
then revert http-client.ts, delete ApiDocs.ts
*/
/*
these files are just informational, only data-contracts.js are currently used
*/
tslib_1.__exportStar(require("./Api"), exports);
tslib_1.__exportStar(require("./data-contracts"), exports);
tslib_1.__exportStar(require("./Db"), exports);
tslib_1.__exportStar(require("./http-client"), exports);
tslib_1.__exportStar(require("./Jsapi"), exports);
//# sourceMappingURL=index.js.map